module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stopCarIndex"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: true
      }
    }
  }, [_vm._v("我的爱车"), (_vm.carList.length < 3) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.addCar
    },
    slot: "right"
  }, [_vm._v("新增")]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "tab_manage"
  }, [_vm._l((_vm.carList), function(item, index) {
    return (_vm.carList.length != 0) ? _c('li', {
      key: index
    }, [_c('div', {
      ref: "child",
      refInFor: true,
      class: [{
        swipeleft: _vm.isSwipe[index]
      }, 'tab_manage_list left'],
      on: {
        "touchstart": function($event) {
          $event.stopPropagation();
          _vm.created()
        }
      }
    }, [_c('p', [_vm._v(_vm._s(item.carNo))]), _vm._v(" "), _c('a', {
      staticClass: "jiebangBtn",
      on: {
        "click": function($event) {
          _vm.removeTodo(index, item)
        }
      }
    }, [_vm._v("解绑")])])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.carList.length == 0),
      expression: "carList.length == 0"
    }]
  }, [_c('div', {
    ref: "child",
    class: [{
      swipeleft: _vm.isSwipe[0]
    }, 'tab_manage_list left'],
    on: {
      "touchstart": function($event) {
        $event.stopPropagation();
        _vm.created()
      }
    }
  }, [_c('p', [_vm._v("未绑定车牌号")]), _vm._v(" "), _c('a', {
    staticClass: "jiebangBtn",
    on: {
      "click": _vm.addCar
    }
  }, [_vm._v("绑定")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#666"
    }
  }, [_vm._v("绑定车牌号，就诊当天可享受停车费五折优惠！")])], 2), _vm._v(" "), _c('x-button', {
    staticClass: "orangeBtn",
    staticStyle: {
      "margin": "15px auto",
      "width": "95%"
    },
    nativeOn: {
      "click": function($event) {
        _vm.payClick($event)
      }
    }
  }, [_vm._v("缴 费")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('x-dialog', {
    staticClass: "stopCarIndexdialog",
    model: {
      value: (_vm.showToast),
      callback: function($$v) {
        _vm.showToast = $$v
      },
      expression: "showToast"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('p', [_vm._v("请输入您的车牌号")]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.$refs.carinput.focus()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carNum),
      expression: "carNum"
    }],
    ref: "carinput",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.carNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.carNum = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "rgb(235, 235, 228)"
    }
  }, [_c('flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.carTxtShow1),
      expression: "carTxtShow1"
    }],
    attrs: {
      "gutter": 0,
      "wrap": "wrap"
    }
  }, _vm._l((_vm.carTxt1), function(item, index) {
    return _c('flexbox-item', {
      key: index,
      attrs: {
        "span": 1 / 6
      },
      nativeOn: {
        "click": function($event) {
          _vm.carTxtClick1(item)
        }
      }
    }, [_c('div', {
      staticClass: "flex-demo"
    }, [_vm._v(_vm._s(item))])])
  })), _vm._v(" "), _c('flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.carTxtShow2),
      expression: "carTxtShow2"
    }],
    attrs: {
      "gutter": 0,
      "wrap": "wrap"
    }
  }, [_vm._l((_vm.carTxt2), function(item, index) {
    return _c('flexbox-item', {
      key: index,
      attrs: {
        "span": 1 / 6
      },
      nativeOn: {
        "click": function($event) {
          _vm.carTxtClick2(item)
        }
      }
    }, [_c('div', {
      staticClass: "flex-demo"
    }, [_vm._v(_vm._s(item))])])
  }), _vm._v(" "), _c('flexbox-item', {
    attrs: {
      "span": 1 / 6
    },
    nativeOn: {
      "click": function($event) {
        _vm.carTxtdel($event)
      }
    }
  }, [_c('div', {
    staticClass: "flex-demo"
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-close",
    staticStyle: {
      "fill": "#a7a7a7",
      "margin-top": "2px"
    },
    attrs: {
      "type": "ios-close",
      "size": "16",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M403.1 108.9c-81.2-81.2-212.9-81.2-294.2 0s-81.2 212.9 0 294.2c81.2 81.2 212.9 81.2 294.2 0s81.2-213 0-294.2zM352 340.2L340.2 352l-84.4-84.2-84 83.8-11.8-11.8 84-83.8-84-83.8 11.8-11.8 84 83.8 84.4-84.2 11.8 11.8-84.4 84.2 84.4 84.2z"
    }
  })])])])], 2)], 1), _vm._v(" "), _c('x-button', {
    staticClass: "bulesolidBtn",
    staticStyle: {
      "margin-right": "6%"
    },
    nativeOn: {
      "click": function($event) {
        _vm.carSubmit($event)
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('x-button', {
    nativeOn: {
      "click": function($event) {
        _vm.showToast = false
      }
    }
  }, [_vm._v("取消")])], 1)])], 1), _vm._v(" "), _c('toast', {
    attrs: {
      "position": "middle",
      "width": "60%",
      "type": "text"
    },
    model: {
      value: (_vm.Toastshow),
      callback: function($$v) {
        _vm.Toastshow = $$v
      },
      expression: "Toastshow"
    }
  }, [_vm._v(_vm._s(_vm.ToastTxt))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ac68ebb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/stopCarProject/stopCarIndex.vue
// module id = WbSl
// module chunks = 6